import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const BloodConsumptionCreatePage = lazy(
  () => import('@/pages/blood-consumption/ui/BloodConsumptionCreatePage'),
)

export const Route = createFileRoute(
  '/_protected/recipients/blood-consumption/new',
)({
  component: () => (
    <Suspense fallback={<Loader />}>
      <BloodConsumptionCreatePage />
    </Suspense>
  ),
})
